// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".icon-logo[data-v-69e5b34e]{flex-shrink:0}.icon-logo__airplane[data-v-69e5b34e],.icon-logo__letters[data-v-69e5b34e]{fill:#fff;transition:fill .3s ease-in-out}.icon-logo--dark .icon-logo__airplane[data-v-69e5b34e],.icon-logo--dark .icon-logo__letters[data-v-69e5b34e]{fill:#003e92}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
